export const DATABASE_NAME = 'owa-offline-system-data';

// Put the system database in its own bucket to isolate from all other activity.
export const BUCKET_NAME: 'owa-offline-system-data' = DATABASE_NAME;
